/** The clips built into public/avatar/orla.glb (see tools/avatar/build-avatar.mjs). */
export const AVATAR_CLIPS = ["Idle", "Jump", "Wave", "Cheer", "Run"] as const;
export type AvatarClip = (typeof AVATAR_CLIPS)[number];

/** Clips that play once and hand back to Idle. */
export const ONE_SHOT_CLIPS = ["Jump", "Wave", "Cheer"] as const;
export type AvatarGesture = (typeof ONE_SHOT_CLIPS)[number];

/** Clips that loop for as long as they are held, then hand back to Idle. */
export type AvatarLoop = "Run";

export const AVATAR_URL = "/avatar/orla.glb";
export const AVATAR_POSTER_URL = "/avatar/orla-poster.webp";
